import { render } from "./SinglePoolDetails.vue?vue&type=template&id=35a5fc38&scoped=true"
import script from "./SinglePoolDetails.vue?vue&type=script&lang=js"
export * from "./SinglePoolDetails.vue?vue&type=script&lang=js"

import "@/Common/Styles/poolDetails.scss?vue&type=style&index=0&id=35a5fc38&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a5fc38"]])

export default __exports__